import React from 'react';
import classNames from 'classnames';
import { Layout } from 'antd';
import AppHeader from './AppHeader/Header';
import AppContent from './AppContent/AppContent';
import Alert from 'AppClient/components/Alert';
import { RouteComponentProps, withRouter } from 'react-router';
import { inject, observer } from 'mobx-react';
import { HistoryStore, RootStore } from 'AppClient/stores';
import { ThemeContext } from 'app-themes';

import style from './AppLayout.module.scss';

interface Props {
	historyStore?: HistoryStore;
}

const AppLayout: React.FC<Props & RouteComponentProps> = props => {
	props.historyStore!.setHistory(props.history);
	return (
		<ThemeContext.Consumer>
			{(theme: string) => (
				<div
					className={classNames(style.appLayout, {
						[style[`appLayout-${theme}`]]: theme !== '',
					})}
				>
					<Layout>
						<AppHeader />
						<AppContent />
						<Alert />
					</Layout>
				</div>
			)}
		</ThemeContext.Consumer>
	);
};

export default inject(({ historyStore }: RootStore) => ({
	historyStore,
}))(observer(withRouter(AppLayout)));
